import {Injectable} from '@angular/core';
import * as hu from '../locales/hu';
import * as en from '../locales/en';

@Injectable()
export class TranslateService {

  public language = 'hu';

  private dictionary = {
    'hu': {
      languange: 'hu',
      values: hu.values
    },
    'en': {
      languange: 'en',
      values: en.values
    }
  };

  constructor() {

  }

  translate(key: string): string {
    if(!key) {
      return '';
    }
    if (key.startsWith('!')) {
      return key.substr(1);
    }
    if (this.dictionary[this.language] != null) {
      return this.dictionary[this.language].values[key];
    }
  }

}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/services/translate.service.ts